import React, {Component, Fragment} from "react";
import { Link, useParams } from 'react-router-dom';
import { FiX , FiMenu } from "react-icons/fi";
import Scrollspy from "react-scrollspy";
import {withTranslation} from "react-i18next";

import BlogContent from "../../elements/blog/BlogContent";
import LanguageDropdown from "../LanguageDropdown";



class Header extends Component{
    constructor(props) {
        super(props);
        this.state = {
            styleName : 'is-current'
        }
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
        window.addEventListener('load', function() {
            console.log('All assets are loaded')
        })
    }

    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }

    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open');
    }

    componentDidMount() {

    }


    render(){

        const PostList = BlogContent.slice(0 , 5);

        window.addEventListener('scroll', function() {
            var value = window.scrollY;
            if (value > 100) {
                document.querySelector('.header--fixed').classList.add('sticky')
            }else{
                document.querySelector('.header--fixed').classList.remove('sticky')
            }
        });

        var elements = document.querySelectorAll('.has-droupdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
        return(
            <header className="header-area formobile-menu header--fixed default-color">
                <div className="header-wrapper" id="header-wrapper">
                    <div className="header-left">
                        <div className="logo">

                            <Link to="/">
                                <img className="logo-1" src="/assets/images/logo/logo-light.png" alt="Logo Images"/>
                                <img className="logo-2" src="/assets/images/logo/logo-all-dark.png" alt="Logo Images"/>
                            </Link>
                        </div>
                    </div>
                    <div className="header-right">
                        <nav className="mainmenunav d-lg-block">
                            <Scrollspy className="mainmenu" items={[]} currentClassName="is-current1" offset={-200}>
                                <li className={window.location.pathname === '/' ? this.state.styleName : null} >
                                    <Link to="/" > {this.props.t("_DEMON_")}</Link>
                                </li>
                                <li  className={window.location.pathname === '/about-us' ? this.state.styleName : null}>
                                    <Link to="/about-us">{this.props.t("_ABOUT_US_")} </Link>
                                </li>
                                <li  className={window.location.pathname === '/partners' ? this.state.styleName : null}>
                                    <Link to="/partners">{this.props.t("_CLIENTS_")} </Link>
                                </li>
                                <li className={window.location.pathname === '/suppliers' ? this.state.styleName : null}>
                                    <Link to="/suppliers">{this.props.t("_SUPPLIERS_")}</Link>
                                </li>
                                <li className={window.location.pathname === '/contact' ? this.state.styleName : null}>
                                    <Link to="/contact">{this.props.t("_CONTACT_")} </Link>
                                </li>
                            </Scrollspy>
                        </nav>

                        <LanguageDropdown/>
                        {/*      <div className="header-btn">
                            <img src={usaFlag} />

                               <a className="rn-btn" href="https://themeforest.net/checkout/from_item/25457315?license=regular">
                                    <span>buy now</span>
                                </a>
                        </div>*/}
                        {/* Start Humberger Menu  */}
                        <div className="humberger-menu d-block d-lg-none pl--20">
                            <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                        </div>
                        {/* End Humberger Menu  */}
                        <div className="close-menu d-block d-lg-none">
                            <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default withTranslation()(Header);
